import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'pelastikon';
const args = {};

export class Pelastikon extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
